import { Box, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';
import { radius } from '@karehero/llama/theme/radius';

import type { NextTask } from '@/north-star/NorthStar.fixtures';

// One task in the triage-driven task list on the home screen. Tapping it drops
// back into the Keni conversation to do the thing. Rendered per task.
export type TaskRowProps = {
  task: NextTask;
  onClick?: () => void;
  done?: boolean;
};

const TaskRow = ({ task, onClick, done = false }: TaskRowProps) => (
  <Stack
    component='button'
    onClick={onClick}
    direction='row'
    spacing={2}
    sx={{
      alignItems: 'center',
      width: '100%',
      p: 2,
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'custom.neutral.200',
      borderRadius: `${radius.lg}px`,
      cursor: 'pointer',
      textAlign: 'left',
      '&:hover': { bgcolor: 'action.hover' },
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        bgcolor: done ? 'custom.limeGreen.100' : 'custom.coral.50',
        color: done ? 'custom.limeGreen.800' : 'custom.coral.700',
      }}
    >
      <Icon icon={(done ? 'circle-check' : task.icon) as never} fontSize={18} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant='subtitle2'
        color={done ? 'text.secondary' : 'text.primary'}
      >
        {task.title}
      </Typography>
      <Typography variant='caption' color='text.secondary'>
        {done ? 'Done' : task.detail}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', color: 'text.disabled' }}>
      <Icon icon={'chevron-right' as never} fontSize={12} />
    </Box>
  </Stack>
);

TaskRow.displayName = 'TaskRow';
export default TaskRow;
